<template>
  <v-container>
    <v-row
        class="d-flex justify-center"
    >

      <v-dialog
          v-model="show"
          :width="loading ? 300 : width"
          :persistent="!closable"
      >

        <v-card v-if="loading">

          <v-card-text class="text-center">

            <div
                class="d-flex justify-center mb-3 pt-3"
            >
              <v-img
                  src="sms-gray.png"
                  max-height="80"
                  max-width="80"
                  contain
              />
            </div>

            <span class="font-weight-bold font-size-h4 ">
              {{ $t("DIALOGS.Waiting") }} ...
            </span>

          </v-card-text>

          <v-divider class="my-0 py-0"></v-divider>

          <v-card-actions class="d-flex justify-center">

            <hollow-dots-spinner
                :animation-duration="1000"
                :dot-size="15"
                :dots-num="3"
                color="#8b8e94"

            />
            <!--          color="#ff1d5e"-->

          </v-card-actions>
        </v-card>

        <v-card v-else> <slot/> </v-card>

      </v-dialog>

    </v-row>
  </v-container>


</template>

<script>
import {HollowDotsSpinner} from 'epic-spinners'

export default {
  name: "WaitStatusDialog",
  components: {HollowDotsSpinner},
  props: {
    show: {
      type: false,
      default: false
    },
    closable: true,
    loading : {
      type:Boolean,
      default:true
    },
    width : {
      default: 500
    }
  },
  watch: {
    show(n, o) {
      this.$emit("onShowChange", n)
    }
  }
}
</script>

<style scoped>

</style>